// Small display helpers shared by the redesigned entity headers.
export function initials(name) {
  return (name || '').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase();
}

// Days from today to a 'dd/mm/yyyy' date (negative when overdue); null when unparseable.
export function daysLeft(date) {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})/.exec(date || '');
  if (!m) return null;
  const end = new Date(+m[3], +m[2] - 1, +m[1]);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((end - today) / 86400000);
}

// TinyMCE skin + content CSS that follow the current light/dark theme (read when the editor mounts).
const TINYMCE_CDN = 'https://cdn.jsdelivr.net/npm/tinymce@5.10.2/skins';
export function editorSkin() {
  const dark = document.documentElement.getAttribute('data-theme') === 'dark';
  const css = getComputedStyle(document.documentElement);
  const bg = css.getPropertyValue('--wx-card').trim() || '#fff';
  const fg = css.getPropertyValue('--wx-text').trim() || '#14142b';
  return {
    skin_url: `${TINYMCE_CDN}/ui/${dark ? 'oxide-dark' : 'oxide'}`,
    content_css: `${TINYMCE_CDN}/content/${dark ? 'dark' : 'default'}/content.css`,
    content_style: `body { background: ${bg}; color: ${fg}; font-family: Inter, system-ui, sans-serif; font-size: 14px; }`,
  };
}
